import React, {useMemo} from 'react';
import {SubmissionStatus} from '../../scaffold';
import {Steps} from 'antd';
import Text from 'antd/lib/typography/Text';

export default function SubmissionSteps(props: {status: SubmissionStatus}) {
  const current = useMemo(() => {
    if ([SubmissionStatus.待上传论文, SubmissionStatus.待导师审核, SubmissionStatus.导师审核需修改].includes(props.status)) {
      return 0;
    }
    if (
      [SubmissionStatus.待分配格式审核, SubmissionStatus.待格式审核, SubmissionStatus.格式审核不通过, SubmissionStatus.待重新上传督导论文].includes(
        props.status,
      )
    ) {
      return 1;
    }
    if (
      [
        // SubmissionStatus.待上传督导论文,
        SubmissionStatus.待分配督导,
        SubmissionStatus.待督导审批,
        SubmissionStatus.督导审批需修改,
        SubmissionStatus.督导审批不通过,
      ].includes(props.status)
    ) {
      return 2;
    }
    if (
      [
        SubmissionStatus.待上传盲审论文,
        SubmissionStatus.待分配盲审,
        SubmissionStatus.待盲审审批,
        SubmissionStatus.盲审审批需修改,
        SubmissionStatus.盲审审批不通过,
        SubmissionStatus.申请完成,
      ].includes(props.status)
    ) {
      return 3;
    }
    return 3;
  }, [props.status]);

  const status: any = {
    [SubmissionStatus.督导审批不通过]: 'error',
    [SubmissionStatus.盲审审批不通过]: 'error',
    [SubmissionStatus.格式审核不通过]: 'error',
    [SubmissionStatus.申请完成]: 'finish',
  };

  const descriptions: any = {
    [SubmissionStatus.待导师审核]: '已提交，等待导师审核',
    [SubmissionStatus.导师审核需修改]: '请修改后再次提交',
    [SubmissionStatus.待上传论文]: '待上传论文',
    [SubmissionStatus.待分配督导]: '等待分配督导',
    [SubmissionStatus.待督导审批]: '等待督导审批',
    [SubmissionStatus.督导审批需修改]: '请修改后再次提交',
    [SubmissionStatus.督导审批不通过]: '审核未通过',
    [SubmissionStatus.格式审核不通过]: '审核未通过',
    [SubmissionStatus.待上传盲审论文]: '待上传盲审论文',
    [SubmissionStatus.待分配格式审核]: '待分配格式审核',
    [SubmissionStatus.待格式审核]: '待格式审核',
    [SubmissionStatus.待重新上传督导论文]: '待重新上传督导论文',
    [SubmissionStatus.待分配盲审]: '等待分配专业盲审',
    [SubmissionStatus.待盲审审批]: '请等待专业盲审审核',
    [SubmissionStatus.盲审审批需修改]: '请修改后再次提交',
    [SubmissionStatus.盲审审批不通过]: '审核未通过',
    [SubmissionStatus.申请完成]: '申请完成',
  };

  return (
    <Steps current={current}>
      <Steps.Step title="导师审批" status={current === 0 ? status[props.status] : undefined} description={current === 0 ? descriptions[props.status] : ''} />
      <Steps.Step title="格式预审" status={current === 1 ? status[props.status] : undefined} description={current === 1 ? descriptions[props.status] : ''} />
      <Steps.Step title="督导审批" status={current === 2 ? status[props.status] : undefined} description={current === 2 ? descriptions[props.status] : ''} />
      <Steps.Step title="专业盲审" status={current === 3 ? status[props.status] : undefined} description={current === 3 ? descriptions[props.status] : ''} />
    </Steps>
  );
}
